import './mult-trip.styles.scss';
import TripGirl from '../../assets/background-images/jovem_mala.png';
import AdvantagesGrid from '../../components/advantages-grid/advantages-grid.component';
import MtSubscriptionsGrid from '../../components/mt-subscriptions-grid/mt-subscriptions-grid.component';

const MultTrip = () => {
  return (
    <div
      className="mult-trip-container"
      style={{ backgroundImage: `url(${TripGirl})` }}
    >
      <div className="welcome-message-container">
        <h1>Seguro viagem Multi-trip</h1>
        <span>
          Os planos de seguro viagem anual Multi Trip são ideais para quem faz 2
          viagens internacionais por ano. A economia é de até 60% comparado aos
          planos convencionais.
        </span>
      </div>
      <div className="introduction-container">
        <h1 className="highlighted">
          Conheça sobre o seguro viagem multi-trip
        </h1>
        <span>
          Se você viaja para o exterior mais de duas vezes ao ano, o Seguro
          Viagem Multi-trip é perfeito para você!
        </span>
        <span>
          Atendendo às exigências do Tratado de Schengen, com o Multi-trip, você
          conta com uma cobertura global - assim, você estará seguro em qualquer
          lugar do mundo para viagens de 30 dias, dentro do prazo de um ano.
        </span>
        <h3 className="highlighted">
          Selecione o plano de seguro viagem que melhor atenda suas necessidades
          e viaje o ano inteiro sem se preocupar
        </h3>
      </div>
      <MtSubscriptionsGrid />
      <AdvantagesGrid />
    </div>
  );
};

export default MultTrip;
